import CloseIcon from "@mui/icons-material/Close";
import { Input, TextArea } from "../../../../../common/Input"; // ADDED
import { useEffect, useMemo, useState } from "react";
import { useEnumsApi } from "../../../../hooks/useEnumsApi";

export function EditApprovedAmountModal({ isOpen, onClose, onUpdate, request }) {

  // 1. Get the list of types (label/value pairs) from your hook
  const { salaryAdvanceTypes } = useEnumsApi();
  
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");

  // 2. Logic to translate the Integer (1) into the Label (Emergency)
  const requestTypeLabel = useMemo(() => {
    if (!salaryAdvanceTypes || request.salaryAdvanceType === undefined) return "N/A";
    
    // Find the object where value matches request.salaryAdvanceType (e.g., 1)
    const typeMatch = salaryAdvanceTypes.find(t => t.value === request.salaryAdvanceType);
    
    // Return the label (Emergency, PreEndorsed, etc.) or just "None"
    return typeMatch ? typeMatch.label : "None";
  }, [salaryAdvanceTypes, request.salaryAdvanceType]);

  useEffect(() => {
    if (isOpen && request) {
      setAmount(request.approvedAmount || request.amount || "");
      setReason(request.approvedAmountReason || "");
    }
  }, [isOpen, request]);

  if (!isOpen || !request) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 text-gray-700 overflow-auto"
    >
      <div className="bg-gray-50 w-full md:w-[90%] lg:w-[50%] xl:w-[40%] rounded-lg shadow-xl h-auto max-h-[90vh] flex flex-col relative">

        {/* Header */}
        <div className="flex justify-between items-center px-6 py-2 border-b border-gray-200 sticky top-0 bg-white z-10 rounded-t-lg shadow-sm">
          <h2 className="text-xl font-semibold text-gray-800 flex items-center space-x-2">
            <span className="text-xl text-gray-600">Set New Approved Amount</span>
          </h2>

          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 transition-colors p-1 bg-transparent border-none cursor-pointer"
            aria-label="Close modal"
          >
            <CloseIcon fontSize="medium" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto flex-grow space-y-4">

          <div className="border border-gray-300 rounded-lg bg-white px-4 shadow-sm pb-4 pt-2">
            <div className="py-1 border-b border-gray-300 mb-4">
              <h3 className="font-medium text-gray-700 uppercase text-xs tracking-widest">Application Information</h3>
            </div>

            {/* Grid for metadata */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4">
              <Input
                label="Reference Number"
                value={request.referenceNumber}
                isViewOnly={true}
              />
               <Input
                label="Request Type"
                value={requestTypeLabel}
                isViewOnly={true}
              />
              <Input
                label="Requested Amount"
                value={`₱${request.amount?.toLocaleString()}`}
                isViewOnly={true}
              />
              <Input
                label="New Approved Amount"
                type="number"
                placeholder="0.00"
                value={amount}
                onChange={(e) => setAmount(e.target.value)} // MODIFIED
              />
            </div>

            <div className="mt-2">
              <TextArea
                label="Reason for Adjustment"
                placeholder="Explain why the amount was changed..."
                value={reason}
                onChange={(e) => setReason(e.target.value)} // MODIFIED
                rows={4}
              />
            </div>
          </div>

        </div>

        {/* Footer */}
        <div className="flex gap-2 justify-end p-5 border-t border-gray-200 bg-white rounded-b-lg shadow-sm">
          <button
            onClick={onClose}
            className="bg-gray-400 hover:bg-gray-500 text-white px-8 py-2 rounded border-none cursor-pointer transition-colors font-medium"
          >
            Close
          </button>
          <button
            onClick={() => onUpdate(amount, reason)}
            className="bg-blue-400 hover:bg-blue-500 text-white px-8 py-2 rounded border-none cursor-pointer transition-colors font-medium"
          >
            Save
          </button>
        </div>

      </div>
    </div>
  );
}